import { Link } from "react-router-dom";
import BrutalButton from "@/components/common/BrutalButton";

export default function NotFound() {
    return (
        <section data-testid="not-found-page" className="py-32 px-6 text-center">
            <span className="label-mono inline-block bg-brand-orange text-white border-2 border-ink rounded-full px-3 py-1">
                404
            </span>
            <h1 className="mt-6 font-display text-6xl md:text-8xl font-black tracking-tighter">
                Page not found.
            </h1>
            <p className="mt-4 font-body text-ink/70 max-w-md mx-auto">
                The page you're looking for took an early lunch. Try one of the
                links in the nav, or head home.
            </p>
            <BrutalButton as={Link} to="/" variant="primary" size="lg" className="mt-8">
                Back home
            </BrutalButton>
        </section>
    );
}
